import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { ClientProvider } from './contexts/ClientContext';
import { AddonProvider } from './contexts/AddonContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { ChatProvider } from './contexts/ChatContext';
import { PersonaProvider } from './contexts/PersonaContext';
import { ToastProvider } from './components/UI/ToastContainer';
import { API_BASE_URL } from './constants';

function App() {
  return (
    <AuthProvider>
      <ClientProvider>
        <AddonProvider>
          <WebSocketProvider apiBaseUrl={API_BASE_URL} autoConnect={false}>
            <PersonaProvider>
              <ChatProvider>
                <ToastProvider position="top-right" maxToasts={5}>
                  <RouterProvider router={router} />
                </ToastProvider>
              </ChatProvider>
            </PersonaProvider>
          </WebSocketProvider>
        </AddonProvider>
      </ClientProvider>
    </AuthProvider>
  );
}

export default App;